import IconComponent from "./Icon";
import { Link } from "react-router-dom";

const WhatsappBot = () => {
  const WHATSAPP_MESSAGE_URL = "https://api.whatsapp.com/send?phone=9150477735&text=Hello%21%20Your%20new%20Hostzop%20website%20looks%20awesome%20I%20have%20a%20new%20enquiry%20regarding%20your%20cloud%20services%2E";

  return (
    <Link to={WHATSAPP_MESSAGE_URL} target="_blank" className="fixed bottom-5 left-5 z-50 bg-green-500 flex justify-center items-center p-3 rounded-full shadow-xl">
      <IconComponent name="whatsapp" size="4xl" color="text-white" />
    </Link>
  );
};

export default WhatsappBot;